export const routeMap: Record<string, { en: string; es: string }> = {
    home: { en: 'home', es: 'inicio' },
    // Aquí definimos las palabras clave traducidas
    roomDetail: { en: 'rooms/:slug', es: 'habitaciones/:slug' },
    restauranteMangle: { en: 'hotel/mangle-restaurant', es: 'hotel/restaurante-mangle' },
    menuMangle: { en: 'hotel/mangle-menu', es: 'hotel/menu-mangle' },
    traslados: { en: 'hotel/transfers', es: 'hotel/traslados' },
    cenasRomanticas: { en: 'hotel/experiences/romantic-dinners', es: 'hotel/experiencias/cenas-romanticas' },
    propuestasMatrimonio: { en: 'hotel/experiences/proposals', es: 'hotel/experiencias/propuestas-de-matrimonio' },
    wellness: { en: 'hotel/wellness', es: 'hotel/wellness' },
    bodas: { en: 'hotel/events/weddings', es: 'hotel/eventos/bodas' },
    ubicacionHolbox: { en: 'holbox/location', es: 'holbox/ubicacion' },
    tipsHolbox: { en: 'holbox/tips', es: 'holbox/tips' },
    toursHolbox: { en: 'holbox/tours', es: 'holbox/tours' },
    contacto: { en: 'contact', es: 'contacto' },
    press: { en: 'press', es: 'prensa' },
    faq: { en: 'faq', es: 'preguntas-frecuentes' },
    galeria: { en: 'gallery', es: 'galeria' },
    compareRooms: { en: 'rooms/compare', es: 'habitaciones/comparar' },
    employe: { en: 'employe', es: 'empleo' },
};